import { Dialog } from "./Dialog"
import SignatureCanvas from "react-signature-canvas"
import { ConfirmOrCancel } from "./ConfirmOrCancel"
import { primary45 } from "../../utils/colors"
import { useRef } from "react"
import Button from "../Button/Button"
import { generateSignatureImage } from "./signatureImage"

// The signing dialog without intent mode: draw, or Auto-Fill with the contact's name. In intent
// mode the public signing pages open SignIntentDialog instead (WS#2211755).
export function AddSigDialog({ onConfirm, onClose, user }) {
  const sigRef = useRef(null)
  const styles = {
    sigContainer: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20,
      fontFamily: 'Roboto'
    },
    sigBlock: {
      display: "inline-block",
      border: `1px solid ${primary45}`,
    },
    instructions: {
      display: "flex",
      justifyContent: "space-between",
      textAlign: "center",
      color: primary45,
      marginTop: 8,
      width: 100,
      alignSelf: "center",
    },
    instructionsContainer: {
      display: "flex",
      justifyContent: "center",
    },
  }


  const handleAutoSignature = async () => {
    const fullName = `${user?.firstName} ${user?.lastName}`
    const generated = await generateSignatureImage(fullName)
    // Одразу викликаємо onConfirm, щоб вставити підпис
    onConfirm(generated)
  }

  const leftBlock = user ? <Button size="md" width="w-max" onClick={handleAutoSignature}>Auto-Fill with My Name</Button> : <></>

  return (
    <Dialog
      isVisible={true}
      title={"Add signature"}
      body={
        <div style={styles.container}>
          <div style={styles.sigContainer}>
            <div style={styles.sigBlock}>
              <SignatureCanvas
                velocityFilterWeight={1}
                ref={sigRef}
                canvasProps={{
                  width: 200,
                  height: 200,
                  className: "sigCanvas",
                }}
              />
            </div>
          </div>
          <ConfirmOrCancel
            leftBlock={leftBlock}
            onCancel={onClose}
            onConfirm={() => {
              // Trim the surrounding whitespace so a hand-drawn signature fills
              // its slot. Placement caps the height, so without trimming the ink
              // (a small part of the 200x200 canvas) renders tiny.
              const sigURL = sigRef.current.isEmpty()
                ? sigRef.current.toDataURL()
                : sigRef.current.getTrimmedCanvas().toDataURL()
              onConfirm(sigURL)
            }}
          />
        </div>
      }
    />
  )
}
